export class HistoricDTOResponse {
  id: number;
  code: string;
  description: string;
  model: string;
}
